"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Add_1 = require("./components/Add");
exports.Add = Add_1.default;
const AddOutlined_1 = require("./components/AddOutlined");
exports.AddOutlined = AddOutlined_1.default;
const ArrowDown_1 = require("./components/ArrowDown");
exports.ArrowDown = ArrowDown_1.default;
const ArrowUp_1 = require("./components/ArrowUp");
exports.ArrowUp = ArrowUp_1.default;
const Color_1 = require("./components/Color");
exports.Color = Color_1.default;
const ColorOutlined_1 = require("./components/ColorOutlined");
exports.ColorOutlined = ColorOutlined_1.default;
const Coupon_1 = require("./components/Coupon");
exports.Coupon = Coupon_1.default;
const DeleteCross_1 = require("./components/DeleteCross");
exports.DeleteCross = DeleteCross_1.default;
const DeleteTrash_1 = require("./components/DeleteTrash");
exports.DeleteTrash = DeleteTrash_1.default;
const DeleteTrashOutlined_1 = require("./components/DeleteTrashOutlined");
exports.DeleteTrashOutlined = DeleteTrashOutlined_1.default;
const Duplicate_1 = require("./components/Duplicate");
exports.Duplicate = Duplicate_1.default;
const EditPencil_1 = require("./components/EditPencil");
exports.EditPencil = EditPencil_1.default;
const Image_1 = require("./components/Image");
exports.Image = Image_1.default;
const ImageOutlined_1 = require("./components/ImageOutlined");
exports.ImageOutlined = ImageOutlined_1.default;
const Lock_1 = require("./components/Lock");
exports.Lock = Lock_1.default;
const MirrorLeft_1 = require("./components/MirrorLeft");
exports.MirrorLeft = MirrorLeft_1.default;
const MirrorRight_1 = require("./components/MirrorRight");
exports.MirrorRight = MirrorRight_1.default;
const Pattern_1 = require("./components/Pattern");
exports.Pattern = Pattern_1.default;
const Search_1 = require("./components/Search");
exports.Search = Search_1.default;
const Share_1 = require("./components/Share");
exports.Share = Share_1.default;
const ShopFront_1 = require("./components/ShopFront");
exports.ShopFront = ShopFront_1.default;
const Star_1 = require("./components/Star");
exports.Star = Star_1.default;
const StockBox_1 = require("./components/StockBox");
exports.StockBox = StockBox_1.default;
const Studio_1 = require("./components/Studio");
exports.Studio = Studio_1.default;
const TShirt_1 = require("./components/TShirt");
exports.TShirt = TShirt_1.default;
const TShirtDashed_1 = require("./components/TShirtDashed");
exports.TShirtDashed = TShirtDashed_1.default;
//# sourceMappingURL=index.js.map